module.exports = __webpack_public_path__ + "24bc66c4ab28327a52caf7b7dad5e19c.pdf";